// Entry point: start the application (title screen → game).

import { App } from './app';

new App().start();
